import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.65, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-1 ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHead = ({ eyebrow, title, lead, align = "left" }) => (
  <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
    <Reveal>
      <p className="eyebrow">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
        {title}
      </h2>
    </Reveal>
    {lead && (
      <Reveal delay={0.16}>
        <p className="mt-3 text-base leading-relaxed text-mist">{lead}</p>
      </Reveal>
    )}
  </div>
);

export const PageHero = ({ eyebrow, lines, lead, children }) => (
  <section className="hero-glow relative overflow-hidden pb-10 pt-28 sm:pb-14 sm:pt-36">
    <div className="container-x relative">
      <Reveal>
        <p className="eyebrow">{eyebrow}</p>
      </Reveal>
      <h1 className="mt-4 max-w-4xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
        {lines.map((line, i) => (
          <MaskedLine key={i} delay={0.1 + i * 0.1}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {lead && (
        <Reveal delay={0.3}>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-mist sm:text-base">{lead}</p>
        </Reveal>
      )}
      {children && <Reveal delay={0.4}>{children}</Reveal>}
    </div>
  </section>
);
